export function SET_ADDRESS(state, address) {
  state.addressSelected = address;
}
